import { render } from "./WatchListsGroup.vue?vue&type=template&id=1c1ea8c9&ts=true"
import script from "./WatchListsGroup.vue?vue&type=script&lang=ts"
export * from "./WatchListsGroup.vue?vue&type=script&lang=ts"

import "./WatchListsGroup.vue?vue&type=style&index=0&id=1c1ea8c9&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__